<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.products.details.title") }}
    </h4>
    <div class="row">
      <div class="col-6 form-group">
        <label class="col-form-label col-12 font-weight-bold">{{$t('app.modules.products.labels.family')}}</label>
        <label class="col-form-label col-12" v-if="producto">{{producto["productoPadre"]}}</label>
        <label class="col-form-label col-12" v-else>N/A</label>

      </div>
      <div class="col-6 form-group">
        <label class="col-form-label col-12 font-weight-bold">{{$t('app.modules.products.labels.sapCode')}}</label>
        <label class="col-form-label col-12" v-if="producto">{{producto["material"]}}</label>
        <label class="col-form-label col-12" v-else>N/A</label>
      </div>
      <div class="col-12 form-group">
        <label class="col-form-label col-12 font-weight-bold">{{$t('app.modules.products.labels.sapDescription')}}</label>

        <label class="col-form-label col-12" v-if="producto">{{producto["textoBreveMaterial"]}}</label>
        <label class="col-form-label col-12" v-else>N/A</label>

      </div>
      <div class="col-12 form-group">
        <label class="col-form-label col-12 font-weight-bold">{{$t('app.modules.products.labels.clientDescES')}}</label>
        <label class="col-form-label col-12" v-if="producto">{{producto["descripcionClienetES"]}}</label>
        <label class="col-form-label col-12" v-else>N/A</label>
      </div>
      <div class="col-12 form-group">
        <label class="col-form-label col-12 font-weight-bold">{{$t('app.modules.products.labels.clientDescEN')}}</label>
        <label class="col-form-label col-12" v-if="producto">{{producto["descripcionClienetEN"]}}</label>
        <label class="col-form-label col-12" v-else>N/A</label>
      </div>
      <div class="col-6 form-group">
        <label class="col-form-label col-12 font-weight-bold">{{$t('app.modules.products.labels.published')}}</label>
        <label class="col-form-label col-12" v-if="producto && producto['publicado']">Si</label>
        <label class="col-form-label col-12" v-else>No</label>
      </div>
      <div class="col-6 form-group">
        <label class="col-form-label col-12 font-weight-bold">{{$t('app.modules.products.labels.enhanced')}}</label>
        <label class="col-form-label col-12" v-if="producto && producto['enriquecido']">Si</label>
        <label class="col-form-label col-12" v-else>No</label>
      </div>
      <div class="col-12 form-group">
        <div class="col-12">
          <h4>{{$t('app.modules.products.labels.productFeatures')}}</h4>
        </div>
        <div class="col-md-12">
          <table class="table">
            <thead>
            <tr>
              <th scope="col">{{$t('app.modules.products.labels.feature')}}</th>
              <th scope="col">{{$t('app.modules.products.labels.value')}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="caracteristica in caracteristicasProducto">
              <td>{{ caracteristica.caractName }}</td>
              <td>{{ caracteristica.valName }}</td>
            </tr>
            <tr v-if="!caracteristicasProducto || !caracteristicasProducto.length">
              <td colspan="2" class="text-center text-muted font-italic">{{$t('app.modules.products.details.noFeaturesAdded')}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div
      slot="footer"
      style="margin-top: 10px; padding-top: 20px;border-top: outset;"
      class="text-right"
    >
      <n-button class="pull-right" @click.native="cancelar()"
      >{{$t('app.modules.products.buttons.close')}}</n-button
      >
    </div>
  </modal>
</template>

<script>
import {getResponse} from "@/util/utilities";
import OrderItemInformation from "@/models/pedidos/OrderItemInformation";

export default {
  name: "ProductDetail",
  data() {
    return {
      modals: {
        classic: false
      },
      idProducto: null,
      producto: [],
      caracteristicas: [],
      caracteristicasProducto: []
    }
  },
  mounted() {
    EventBus.$on("product-details", async idProducto => {
      await this.init(idProducto);
    });
  },
  methods: {
    async init(idProducto) {
      this.showLoader();
      this.idProducto = idProducto;
      await this.getCaracteristicas();
      await this.getProducto(idProducto);
      this.closeLoader();
      this.modals.classic = true;
    },
    cancelar() {
      this.modals.classic = false;
    },
    showLoader(){
      this.$swal.fire({
        title: "Por favor espera",
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
    },
    closeLoader(){
      this.$swal.close();
    },
    async getCaracteristicas(){
      this.caracteristicas = [];
      try {
        let request = await this.$http.get(route("CaracteristicasProducto/getCaratacteristicasProducto"))
        let caracteristicas = getResponse(request, null, body => body.caracteristicasProducto);
        caracteristicas = caracteristicas || [];
        this.handleCaracteristicas(caracteristicas);
      } catch (e) {
        console.error(e);
      }
    },
    handleCaracteristicas(caracteristicasArray){
      var selected_lang = 3;
      if(caracteristicasArray){
        var traducciones = [];
        caracteristicasArray.forEach(element =>{
          traducciones = element.traduccion;
          var key = 0;
          var txt = '';
          var values = [];
          var current_lang_trads = traducciones.filter(it => {
            return it.idiomas_idIdioma == selected_lang;
          });
          if(!current_lang_trads.length){
            current_lang_trads = traducciones.filter(it => {
              return it.idiomas_idIdioma == 1
            });
          }
          if(current_lang_trads){
            key = element.idcaracteristicasProducto;
            txt = current_lang_trads[0].nombreAtributo;
            values = JSON.parse(current_lang_trads[0].valorAtributo);
            this.caracteristicas.push({key: key, txt: txt, values: values});
          }
        });
      }
    },
    async getProducto(id){
      const params = {
        /*Id: id,
        ClaveIdioma: this.$store.state.lang,
        Usuario: 0,
        clienteId: id*/
        idProducto: id
      };

      this.productos = [];

      try {
        let productoRequest = await this.$http.post(route("Productos/getInformacionProducto"), params)

        let producto = getResponse(productoRequest, null, body => body.producto);
        producto = producto || null;

        this.producto = producto;
        this.handleProduct(this.producto);
      }
      catch (e)
      {
        console.error(e);
      }
    },
    handleProduct(productoArray){
      this.caracteristicasProducto = [];
      var caracts = productoArray['caracteristicas'];
      if(caracts && caracts.length){
        caracts.forEach(cat => {
          var catName = this.findCaractName(cat.idCaracteristicasProducto);
          var valName = this.findValName(cat.idCaracteristicasProducto, cat.valorCaracteristica);
          this.pushToCats(cat.idProductoCaracteristicas, cat.idCaracteristicasProducto,catName, cat.valorCaracteristica,valName)
        });
      }
    },
    pushToCats(id, idCat, catName, val, valName){
      this.caracteristicasProducto.push({
        idProductoCaracteristicas: null,
        idCaracterostocaProducto: idCat,
        caractName: catName,
        valor: val,
        valName: valName});

    },
    findCaractName(key){
      var selectedCaractArr = this.caracteristicas.filter(it => {return it.key == key});
      var caractName = selectedCaractArr[0].txt;
      return caractName;
    },
    findValName(caractKey, valKey){
      var selectedCaracteristicaArray = this.caracteristicas.filter(function (it){
        return it.key === caractKey;
      });
      var selectedVals = selectedCaracteristicaArray[0].values;
      return selectedVals[valKey];
    }
  }
};
</script>

<style scoped>

</style>
